import React from 'react';
import PropTypes from 'prop-types';
import { Avatar } from 'xland-ui';
import { getStartupVerifiedIcon } from 'utils/functions';

function StartupRowHeader({
  name, logo, verified, legalName,
}) {
  return (
    <div className='company_header'>
      <Avatar title={name} src={logo?.path} size={40} />
      <div className='company_info'>
        <div className='company_info--left'>
          <span className='company_name'>{name}</span>
          {legalName && (
            <span className='company_legal_name'>{legalName}</span>
          )}
        </div>
        {getStartupVerifiedIcon(verified)}
      </div>
    </div>
  );
}

StartupRowHeader.propTypes = {
  name: PropTypes.string.isRequired,
  logo: PropTypes.object,
  verified: PropTypes.string,
  legalName: PropTypes.string,
};

export default StartupRowHeader;
